module.exports = __webpack_public_path__ + "img/pts-logo.9c5ba0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pts-logo.png
// module id = 1096
// module chunks = 0